/* global HTMLElement, customElements */

class SubmenuElement extends HTMLElement {
  static observedAttributes = ['open']

  constructor () {
    super()

    this.$toggle = this.querySelector('.js-submenu__toggle')
    this.$items = this.querySelector('.js-submenu__items')

    if (!this.$toggle) {
      // static submenu without toggle
      return
    }

    this.$toggle.addEventListener('click', () => this.toggle())
    this.$toggle.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') {
        this.toggle(true)
        return
      }

      if (e.key === 'ArrowLeft') {
        this.toggle(false)
      }
    })
  }

  toggle (force) {
    const newState = (typeof force !== 'undefined')
      ? force
      : (this.getAttribute('open') === null)
    this.$toggle.setAttribute('aria-expanded', newState.toString())
    this.$items.inert = !newState

    if (newState) {
      this.setAttribute('open', '')
    } else {
      this.removeAttribute('open')
    }
  }

  attributeChangedCallback (name, oldValue, newValue) {
    if (newValue === oldValue) {
      return
    }

    if (name !== 'open') {
      return
    }

    this.toggle(newValue !== null)
  }
}

customElements.define('x-submenu', SubmenuElement)
